import React, { useState, useEffect } from 'react';
import { getNotices, addNotice } from '../../api';
import { toast } from 'react-toastify';

const NoticeBoard = () => {
  const [notices, setNotices] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ title: '', content: '' });

  useEffect(() => { loadNotices(); }, []);

  const loadNotices = async () => {
    try {
      const res = await getNotices();
      setNotices(res.data);
    } catch (err) {
      toast.error('Error loading notices');
    }
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    try {
      await addNotice(formData);
      toast.success('Notice added!');
      setShowForm(false);
      setFormData({ title: '', content: '' });
      loadNotices();
    } catch (err) {
      toast.error('Error adding notice');
    }
  };

  return (
    <div>
      <div style={styles.header}>
        <h3 style={styles.title}>📢 Notice Board</h3>
        <button style={styles.addBtn} onClick={() => setShowForm(!showForm)}>
          + Add Notice
        </button>
      </div>

      {showForm && (
        <div style={styles.formCard}>
          <h4 style={styles.formTitle}>Add New Notice</h4>
          <form onSubmit={handleAdd}>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Title</label>
              <input style={styles.input} placeholder="Notice title"
                value={formData.title}
                onChange={e => setFormData({...formData, title: e.target.value})} required />
            </div>
            <div style={styles.inputGroup}>
              <label style={styles.label}>Content</label>
              <textarea style={styles.textarea} placeholder="Notice details..."
                value={formData.content} rows={4}
                onChange={e => setFormData({...formData, content: e.target.value})} required />
            </div>
            <div style={styles.btnGroup}>
              <button type="submit" style={styles.addBtn}>Post Notice</button>
              <button type="button" style={styles.cancelBtn}
                onClick={() => setShowForm(false)}>Cancel</button>
            </div>
          </form>
        </div>
      )}

      <div style={styles.noticesList}>
        {notices.length === 0 && (
          <div style={styles.empty}>No notices yet. Add one above!</div>
        )}
        {notices.map(n => (
          <div key={n.id} style={styles.noticeCard}>
            <div style={styles.noticeHeader}>
              <h4 style={styles.noticeTitle}>📌 {n.title}</h4>
              <span style={styles.noticeDate}>
                {new Date(n.created_at).toLocaleDateString()}
              </span>
            </div>
            <p style={styles.noticeContent}>{n.content}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

const styles = {
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
  title: { color: '#1a3a5c', margin: 0 },
  addBtn: { padding: '10px 20px', background: '#0d6efd', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' },
  cancelBtn: { padding: '10px 20px', background: '#6c757d', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer' },
  formCard: { background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' },
  formTitle: { color: '#1a3a5c', margin: '0 0 15px' },
  inputGroup: { marginBottom: '15px' },
  label: { fontSize: '13px', fontWeight: '600', color: '#555', display: 'block', marginBottom: '5px' },
  input: { padding: '10px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px', width: '100%' },
  textarea: { padding: '10px', border: '1px solid #ddd', borderRadius: '6px', fontSize: '14px', width: '100%', resize: 'vertical' },
  btnGroup: { display: 'flex', gap: '10px' },
  noticesList: { display: 'flex', flexDirection: 'column', gap: '15px' },
  empty: { textAlign: 'center', color: '#999', padding: '40px', background: 'white', borderRadius: '12px' },
  noticeCard: { background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.08)', borderLeft: '4px solid #0d6efd' },
  noticeHeader: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' },
  noticeTitle: { color: '#1a3a5c', margin: 0, fontSize: '16px' },
  noticeDate: { color: '#999', fontSize: '12px' },
  noticeContent: { color: '#555', fontSize: '14px', lineHeight: '1.6', margin: 0 },
};

export default NoticeBoard;